import { startCase } from 'lodash';
import { Calendar, Clock, User, Zap } from 'lucide-react';
import { formatDate } from 'utils/helpers';

const Item = ({ onClick, item, isDropdownOpen }) => {
  const { appointment_at, codes, provider, status } = item?.attributes || {};
  const { first_name, last_name } = provider?.data?.attributes || {}

  return (
    <div
      onClick={() => onClick()}
      className="border border-slate-100 rounded-lg p-4 bg-white shadow-sm space-y-3 cursor-pointer hover:border-slate-200 hover:shadow transition-all duration-200 flex flex-col relative"
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-1.5 text-secondary-650">
            <Calendar className="w-3.5 h-3.5 text-secondary-500" />
            <span className="text-xs font-semibold text-secondary-900">{formatDate(appointment_at)}</span>
          </div>
          <div className="flex items-center gap-1.5 text-secondary-650">
            <Clock className="w-3.5 h-3.5 text-secondary-500" />
            <span className="text-xs font-semibold text-secondary-900">{formatDate(appointment_at, 'twelveHour')}</span>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <span className="bg-[#eff6ff] text-blue-600 text-[10px] font-semibold px-2 py-0.5 rounded-full">{startCase(status)}</span>
          <svg className={`w-3.5 h-3.5 text-secondary-400 transition-transform ${isDropdownOpen ? 'rotate-180' : ''}`}
            fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2.5">
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
          </svg>
        </div>
      </div>

      <div className="flex items-center gap-1.5 text-secondary-650 text-[10px] pl-0.5">
        <User className="w-3 h-3 shrink-0 text-secondary-400" />
        <span className="text-secondary-850 font-medium">{first_name} {last_name}</span>
        <span className="text-secondary-400">{codes}</span>
      </div>

      <div className="flex flex-wrap items-center gap-4 text-[10px] font-bold pt-1.5 border-t border-slate-50">
        {true && (
          <div className="flex items-center gap-1 text-blue-600">
            <Zap className="w-3 h-3 fill-blue-600 stroke-blue-600" />
            <span>Auto-selected</span>
          </div>
        )}
      </div>
    </div>
  )
}

export default Item
